export class ModeratedOfferInput {
  operatorPurchaseOfferId: string = null;
  recommendedOffer: boolean = false;
  offerComment: string = null;
}
